import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { Container } from 'react-bootstrap';

import { getRelatedContentsByProducts, getPosts, memoizedGetPosts, getRelatedContentsByCategories } from '../../../Cms/CmsActions.js';

import { getTranslation } from '../../../Intl/IntlHelper.js';
import PostCardGrid from '../../../Cms/components/view/PostCardGrid.js';

function ProductRelatedPosts({ locale, page, products, categories = '', posts = [], titleKeyword = '', hideTitle = false, mode = 'full', excerptSize = 80, count = null }) {
	const [relatedPosts, setRelatedPosts] = useState(posts);

	useEffect(() => {
		const productsRelatedPosts = getRelatedContentsByProducts(products, posts, locale, page && [page]);
		setRelatedPosts([
			...productsRelatedPosts,
			...getRelatedContentsByCategories(categories, posts, locale, productsRelatedPosts),
		]);
	}, []);

    if(!relatedPosts.length) {
        return null;
    }
    const titleKey = titleKeyword || (products.length === 1 && getTranslation(products[0], 'name', locale));

    return (
		<Container className="mb-4 px-2 px-md-0">
            {!hideTitle && (
                <div className="text-center mb-4">
                    <h2 className="h3 fw-bold text-dark mb-2">
                        {
                            titleKey
                            ? <FormattedMessage id="productPostsAboutTitle" defaultMessage="Learn more about {product}" values={{ product: titleKey }} />
                            : <FormattedMessage id="learnMoreButton" defaultMessage="Learn more" />
                        }
                    </h2>
                    <div className="mx-auto rounded-pill bg-danger" style={{ width: '46px', height: '3px' }} />
                </div>
            )}
            <PostCardGrid posts={count ? relatedPosts.slice(0, count) : relatedPosts} excerptSize={excerptSize} />
		</Container>
    );
}

function mapStateToProps(store, props) {
    return {
        locale: store.intl.locale,
        posts: memoizedGetPosts(store, store.intl.locale, null),
    };
}

ProductRelatedPosts.propTypes = {
    locale: PropTypes.string.isRequired,
	page: PropTypes.object.isRequired,
    products: PropTypes.arrayOf(PropTypes.object).isRequired,
	categories: PropTypes.arrayOf(PropTypes.string),
    posts: PropTypes.arrayOf(PropTypes.object),
    titleKeyword: PropTypes.string,
	hideTitle: PropTypes.bool,
    mode: PropTypes.string,
	excerptSize: PropTypes.number,
	count: PropTypes.number,
};

export default connect(mapStateToProps)(ProductRelatedPosts);
